/**
 * Asset configuration for all game assets
 * Defines all image and audio assets that need to be preloaded
 */

export interface ImageAssetConfig {
  id: string;
  src: string;
  category: 'backdrop' | 'background' | 'character' | 'cutscene' | 'ui' | 'item';
  preload?: boolean;
}

export interface AudioAssetConfig {
  id: string;
  src: string;
  category: 'music' | 'sfx' | 'voice' | 'ambient';
  loop?: boolean;
  volume?: number;
  preload?: boolean;
}

/**
 * All image assets in the game
 */
export const imageAssets: ImageAssetConfig[] = [
  //UI assets
  {
    id: 'b_interaction1',
    src: 'assets/ui/b_interaction1.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'b_interaction2',
    src: 'assets/ui/b_interaction2.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'b_inventory1',
    src: 'assets/ui/b_inventory1.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'b_inventory2',
    src: 'assets/ui/b_inventory2.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'b_question',
    src: 'assets/ui/b_question.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'b_volumeoff',
    src: 'assets/ui/b_volumeoff.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'b_volumeon',
    src: 'assets/ui/b_volumeon.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'day_progress_bar',
    src: 'assets/ui/Bar.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'choices_selector',
    src: 'assets/ui/choices_selector.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'gallery',
    src: 'assets/ui/gallery.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'icon-gallery',
    src: 'assets/ui/icon-gallery.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'icon-share',
    src: 'assets/ui/icon-share.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'icon-try-again',
    src: 'assets/ui/icon-try-again.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'inventory_background',
    src: 'assets/ui/inventory_background.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'Tutorial-Mobile',
    src: 'assets/ui/Tutorial-Mobile.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'Tutorial-PC',
    src: 'assets/ui/Tutorial-PC.png',
    category: 'ui',
    preload: true,
  },

  {
    id: 'day-indicator',
    src: 'assets/misc/day-indicator.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'dialog-box',
    src: 'assets/misc/dialog-box.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'vignet_eye_v2.png',
    src: 'assets/misc/vignet_eye_v2.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'vignette.png',
    src: 'assets/misc/vignette.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'vignette_arch.png',
    src: 'assets/misc/vignette_arch.png',
    category: 'ui',
    preload: true,
  },
  {
    id: 'vignette_eye.png',
    src: 'assets/misc/vignette_eye.png',
    category: 'ui',
    preload: true,
  },


  // NPC assets
  {
    id: 'invis2',
    src: 'assets/npc/invis2.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sparkle',
    src: 'assets/npc/sparkle.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes',
    src: 'assets/npc/karakter_tes.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes1',
    src: 'assets/npc/karakter_tes1.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'item_dust',
    src: 'assets/npc/item_dust.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_karakter_tes2',
    src: 'assets/npc/karakter_tes2.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_pancingan',
    src: 'assets/sprite/sprite_pancingan.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_ato',
    src: 'assets/sprite/sprite_ato.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_ato_holga',
    src: 'assets/sprite/sprite_ato_holga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_stake',
    src: 'assets/sprite/sprite_stake.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_bunga',
    src: 'assets/sprite/sprite_bunga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_darius',
    src: 'assets/sprite/sprite_darius.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_diana',
    src: 'assets/sprite/sprite_diana.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_elsa',
    src: 'assets/sprite/sprite_elsa.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_stake_elsa',
    src: 'assets/sprite/sprite_stake_elsa.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_holga',
    src: 'assets/sprite/sprite_holga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_nenek1',
    src: 'assets/sprite/sprite_nenek1.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_nenek2',
    src: 'assets/sprite/sprite_nenek2.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_npc_lady',
    src: 'assets/sprite/sprite_npc_lady.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_npc_mom',
    src: 'assets/sprite/sprite_npc_mom.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_npc_nenek',
    src: 'assets/sprite/sprite_npc_nenek.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_sondakh',
    src: 'assets/sprite/sprite_sondakh.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_sondakh_dead',
    src: 'assets/sprite/sprite_sondakh_dead.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_gate_close',
    src: 'assets/sprite/gate_close.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sprite_gate_open',
    src: 'assets/sprite/gate_open.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'ato_up',
    src: 'assets/sprite/ato_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_up',
    src: 'assets/sprite/elsa_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'mob2_up',
    src: 'assets/sprite/mob2_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'nenek2_up',
    src: 'assets/sprite/nenek2_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sondakh_up',
    src: 'assets/sprite/sondakh_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga_up',
    src: 'assets/sprite/bunga_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'holga_up',
    src: 'assets/sprite/holga_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'mob3_up',
    src: 'assets/sprite/mob3_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_crowd',
    src: 'assets/sprite/npc_crowd.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_crowd_animated',
    src: 'assets/sprite/crowd_animated.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'small_sparkle',
    src: 'assets/sprite/small_sparkle.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'glitter',
    src: 'assets/sprite/glitter.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'glitterV2',
    src: 'assets/sprite/glitter_v2.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'glitter_small',
    src: 'assets/sprite/glitter_small.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'npc_crowd_animated_flipped',
    src: 'assets/sprite/crowd_animated_flipped.gif',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana_up',
    src: 'assets/sprite/diana_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'mob1_up',
    src: 'assets/sprite/mob1_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'nenek1_up',
    src: 'assets/sprite/nenek1_up.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'romo_up',
    src: 'assets/sprite/romo_up.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'clickable_indicator',
    src: 'assets/sprite/clickable_indicator.png',
    category: 'character',
    preload: true,
  },

  // Background assets
  {
    id: 'background_map',
    src: 'assets/background/map.jpg',
    category: 'background',
    preload: true,
  },

  // Backdrop assets
  {
    id: 'backdrop_danau',
    src: 'assets/backdrop/danau.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_kamar_yan',
    src: 'assets/backdrop/kamar_yan.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'interior_bar',
    src: 'assets/backdrop/warteg.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'portal',
    src: 'assets/backdrop/portal.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'portal_yan',
    src: 'assets/backdrop/portal-yan.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_gereja',
    src: 'assets/backdrop/gereja.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_hutan',
    src: 'assets/backdrop/hutan.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_interior_rumah',
    src: 'assets/backdrop/interior_rumah.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_sofa',
    src: 'assets/backdrop/ruang_tamu_sofa.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_meja_makan_zoomed',
    src: 'assets/backdrop/ruang_tamu_meja_makan_zoomed.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_kalender',
    src: 'assets/backdrop/ruang_tamu_kalender.ktx2',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'backdrop_stake_empty',
    src: 'assets/backdrop/stake_empty.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_elsa',
    src: 'assets/backdrop/stake_elsa.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_bunga',
    src: 'assets/cutscene/stake_bunga.ktx2',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'backdrop_stake_nenek',
    src: 'assets/cutscene/stake_nenek.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_yanf',
    src: 'assets/cutscene/stake_yanf.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_yanm',
    src: 'assets/cutscene/stake_yanm.ktx2',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'elsa_sleep',
    src: 'assets/backdrop/elsa_sleep.ktx2',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'backdrop_stake_on_fire',
    src: 'assets/backdrop/stake_on_fire.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_on_fire_2',
    src: 'assets/backdrop/stake_on_fire_2.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_with_person',
    src: 'assets/backdrop/stake_with_person.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_stake_holga',
    src: 'assets/cutscene/stake_holga.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'backdrop_ruang_tamu_zoomed',
    src: 'assets/backdrop/ruang_tamu_zoomed.ktx2',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'cutscene_mandi_bunga',
    src: 'assets/cutscene/mandi_bunga.ktx2',
    category: 'cutscene',
    preload: true,
  },

  {
    id: 'cutscene_burning_shadow_a',
    src: 'assets/cutscene/burning_shadow_a.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_burning_shadow_b',
    src: 'assets/cutscene/burning_shadow_b.ktx2',
    category: 'cutscene',
    preload: true,
  },


  {
    id: 'backdrop_rumah',
    src: 'assets/backdrop/rumah.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'desa',
    src: 'assets/backdrop/desa.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'kamar_diana',
    src: 'assets/backdrop/kamar_diana.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'kamar_nenek',
    src: 'assets/backdrop/kamar_nenek.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'kamar_nenek_fill',
    src: 'assets/backdrop/kamar_nenek_fill.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'kamar_nenek_zoom',
    src: 'assets/backdrop/kamar_nenek_zoom.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'warteg',
    src: 'assets/backdrop/warteg.png',
    category: 'backdrop',
    preload: true,
  },
  // Character assets (original size)
  {
    id: 'ato',
    src: 'assets/character/v2/ato.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'ato_a',
    src: 'assets/character/v2/ato_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'little_girl',
    src: 'assets/character/v2/little_girl_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'little_girl_h',
    src: 'assets/character/v2/little_girl_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'little_girl_n',
    src: 'assets/character/v2/little_girl.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga',
    src: 'assets/character/v2/bunga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga_a',
    src: 'assets/character/v2/bunga_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'bunga_h',
    src: 'assets/character/v2/bunga_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'darius',
    src: 'assets/character/v2/darius.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana',
    src: 'assets/character/v2/diana.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'diana_h',
    src: 'assets/character/v2/diana_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana_p',
    src: 'assets/character/v2/diana_p.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'diana_s',
    src: 'assets/character/v2/diana_s.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'elsa',
    src: 'assets/character/v2/elsa.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'elsa_h',
    src: 'assets/character/v2/elsa_h.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_a',
    src: 'assets/character/v2/elsa_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_c',
    src: 'assets/character/v2/elsa_c.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_p',
    src: 'assets/character/v2/elsa_p.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'elsa_s',
    src: 'assets/character/v2/elsa_s.png',
    category: 'character',
    preload: true,
  },


  {
    id: 'holga',
    src: 'assets/character/v2/holga.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'holga_a',
    src: 'assets/character/v2/holga_a.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'holga_s',
    src: 'assets/character/v2/holga_s.png',
    category: 'character',
    preload: true,
  },

  {
    id: 'nenek',
    src: 'assets/character/v2/nenek.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'sondakh',
    src: 'assets/character/v2/sondakh.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'yanf',
    src: 'assets/character/v2/yanf.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'yanm',
    src: 'assets/character/v2/yanm.png',
    category: 'character',
    preload: true,
  },
  {
    id: 'shop_clerk',
    src: 'assets/character/v2/shop_clerk.png',
    category: 'character',
    preload: true,
  },

  { id: 'ato_sy', src: 'assets/character/v2/ato.png', category: 'character', preload: true },
  { id: 'darius_h', src: 'assets/character/v2/darius.png', category: 'character', preload: true },
  { id: 'elsa_sys', src: 'assets/character/v2/elsa.png', category: 'character', preload: true },
  { id: 'yanf_n', src: 'assets/character/v2/yanf.png', category: 'character', preload: true },
  { id: 'yanm_n', src: 'assets/character/v2/yanm.png', category: 'character', preload: true },
  { id: 'bunga_p', src: 'assets/character/v2/bunga.png', category: 'character', preload: true },
  { id: 'darius_sy', src: 'assets/character/v2/darius.png', category: 'character', preload: true },
  { id: 'nenek_a', src: 'assets/character/v2/nenek.png', category: 'character', preload: true },
  { id: 'yanf_p', src: 'assets/character/v2/yanf.png', category: 'character', preload: true },
  { id: 'yanm_p', src: 'assets/character/v2/yanm.png', category: 'character', preload: true },
  { id: 'bunga_sy', src: 'assets/character/v2/bunga.png', category: 'character', preload: true },
  { id: 'diana_sy', src: 'assets/character/v2/diana.png', category: 'character', preload: true },
  { id: 'nenek_sy', src: 'assets/character/v2/nenek.png', category: 'character', preload: true },
  { id: 'yanf_sy', src: 'assets/character/v2/yanf.png', category: 'character', preload: true },
  { id: 'yanm_sy', src: 'assets/character/v2/yanm.png', category: 'character', preload: true },
  { id: 'darius_a', src: 'assets/character/v2/darius.png', category: 'character', preload: true },
  { id: 'elsa_ssm', src: 'assets/character/v2/elsa.png', category: 'character', preload: true },
  { id: 'yanf_d', src: 'assets/character/v2/yanf.png', category: 'character', preload: true },
  { id: 'yanm_d', src: 'assets/character/v2/yanm.png', category: 'character', preload: true },

  // Cutscene assets
  {
    id: 'cutscene_d1_crowd',
    src: 'assets/cutscene/D1_crowd.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_ato_bogem',
    src: 'assets/cutscene/ato_bogem.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'custcene_ato_pull',
    src: 'assets/cutscene/ato_pull.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_diana_pray',
    src: 'assets/cutscene/diana_pray.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_grave_empty',
    src: 'assets/backdrop/grave_empty.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_sleep_bunga',
    src: 'assets/backdrop/sleep_bunga.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_sleep_elsa',
    src: 'assets/backdrop/sleep_elsa.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'cutscene_d2_win',
    src: 'assets/cutscene/D2_WIN.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_win_2',
    src: 'assets/cutscene/D2_WIN_2.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack',
    src: 'assets/cutscene/D2_songko_attack.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_covered',
    src: 'assets/cutscene/D2_songko_attack_covered.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_covered_blood',
    src: 'assets/cutscene/D2_songko_attack_covered_blood.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_girl',
    src: 'assets/cutscene/D2_songko_attack_girl.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_girl_1',
    src: 'assets/cutscene/D2_songko_attack_girl_1.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_girl_2',
    src: 'assets/cutscene/D2_songko_attack_girl_2.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_attack_splatter',
    src: 'assets/cutscene/D2_songko_attack_splatter.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_d2_songko_block',
    src: 'assets/cutscene/D2_songko_block.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_danau_bh',
    src: 'assets/cutscene/DANAU_BH.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_spoiler_image',
    src: 'assets/cutscene/SPOILER_image.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_black',
    src: 'assets/cutscene/black.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy',
    src: 'assets/cutscene/death_boy.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy_v2',
    src: 'assets/cutscene/death_boy_v2.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy_v2_dor',
    src: 'assets/cutscene/death_boy_v2_dor.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_boy_v2_floor',
    src: 'assets/cutscene/death_boy_v2_floor.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_1',
    src: 'assets/cutscene/death_crowd_1.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_2',
    src: 'assets/cutscene/death_crowd_2.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_3',
    src: 'assets/cutscene/death_crowd_3.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_crowd_4',
    src: 'assets/cutscene/death_crowd_4.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_sondakh_death',
    src: 'assets/cutscene/death_sondakh.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_sondakh_death_kalung',
    src: 'assets/cutscene/death_sondakh_kalung.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_death_diana_blood_zoom',
    src: 'assets/cutscene/death_diana_blood_zoom.ktx2',
    category: 'cutscene',
    preload: true,
  },



  {
    id: 'cutscene_secret_1',
    src: 'assets/cutscene/secret/1.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_1b',
    src: 'assets/cutscene/secret/1b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_2',
    src: 'assets/cutscene/secret/2.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_2b',
    src: 'assets/cutscene/secret/2b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_3',
    src: 'assets/cutscene/secret/3.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_3b',
    src: 'assets/cutscene/secret/3b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_4',
    src: 'assets/cutscene/secret/4.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_4b',
    src: 'assets/cutscene/secret/4b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_5',
    src: 'assets/cutscene/secret/5.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_5b',
    src: 'assets/cutscene/secret/5b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_6',
    src: 'assets/cutscene/secret/6.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_6b',
    src: 'assets/cutscene/secret/6b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_7a',
    src: 'assets/cutscene/secret/7a.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_7b',
    src: 'assets/cutscene/secret/7b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_9a',
    src: 'assets/cutscene/secret/9a.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_9b',
    src: 'assets/cutscene/secret/9b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_9c',
    src: 'assets/cutscene/secret/9c.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_10a',
    src: 'assets/cutscene/secret/10a.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_10b',
    src: 'assets/cutscene/secret/10b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_11a',
    src: 'assets/cutscene/secret/11a.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'cutscene_secret_11b',
    src: 'assets/cutscene/secret/11b.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'portal_exit_1',
    src: 'assets/cutscene/portal_exit_1.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'portal_exit_2',
    src: 'assets/cutscene/portal_exit_2.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'portal_exit_3',
    src: 'assets/cutscene/portal_exit_3.ktx2',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'rumput',
    src: 'assets/cutscene/rumput.jpeg',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'songko_attacks',
    src: 'assets/cutscene/SONGKO_JUMP.ktx2',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'ground_a_nothing',
    src: 'assets/cutscene/ground_a_nothing.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'songko_v_sondakh',
    src: 'assets/cutscene/songko_v_sondakh.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'songko_v_diana',
    src: 'assets/cutscene/songko_v_diana.ktx2',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'happy_ending',
    src: 'assets/cutscene/happy_ending.png',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'portal_inverted',
    src: 'assets/cutscene/portal_inverted.png',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'sad_ending_yanf',
    src: 'assets/cutscene/sad_ending_yanf.png',
    category: 'backdrop',
    preload: true,
  },
  {
    id: 'sad_ending_yanm',
    src: 'assets/cutscene/sad_ending_yanm.png',
    category: 'backdrop',
    preload: true,
  },

  {
    id: 'ground_scare_1',
    src: 'assets/cutscene/ground_scare_1.jpg',
    category: 'cutscene',
    preload: true,
  },
  {
    id: 'ground_scare_2',
    src: 'assets/cutscene/ground_scare_2.jpg',
    category: 'cutscene',
    preload: true,
  },

  // Items assets
  {
    id: 'item_boneka',
    src: 'assets/items/item_boneka.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_drink',
    src: 'assets/items/item_drink2.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_panada',
    src: 'assets/items/item_panada.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_uang',
    src: 'assets/items/item_uang.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_bible',
    src: 'assets/items/item_bible.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_ikan',
    src: 'assets/items/item_ikan.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_liontin',
    src: 'assets/items/item_liontin.png',
    category: 'item',
    preload: true,
  },
  {
    id: 'item_sendal',
    src: 'assets/items/item_sendal.png',
    category: 'item',
    preload: true,
  },
];

/**
 * All audio assets (imported from SoundConfig)
 */
export const audioAssets: AudioAssetConfig[] = [
  // Music
  {
    id: 'music_musicBox',
    src: 'assets/audio/bgm/bg-music-box.mp3',
    category: 'music',
    loop: true,
    volume: 0.5,
    preload: true,
  },
  {
    id: 'music_piano',
    src: 'assets/audio/bgm/bg-piano.mp3',
    category: 'music',
    loop: true,
    volume: 0.1,
    preload: true,
  },
  {
    id: 'music_standing_by',
    src: 'assets/audio/bgm/music-standing-by.mp3',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },
  {
    id: 'music_tense',
    src: 'assets/audio/bgm/music-tense.mp3',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },
  {
    id: 'music_super_tense',
    src: 'assets/audio/bgm/music-super-tense.mp3',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },

  {
    id: 'music_bad_chase_scene',
    src: 'assets/audio/bgm_ogg/bad_chase_scene.ogg',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },
  {
    id: 'music_bad_ending',
    src: 'assets/audio/bgm_ogg/bad_ending.ogg',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },
  {
    id: 'music_happy_a',
    src: 'assets/audio/bgm_ogg/happy_a.ogg',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },
  {
    id: 'music_happy_b',
    src: 'assets/audio/bgm_ogg/happy_b.ogg',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },
  {
    id: 'music_secret_ending',
    src: 'assets/audio/bgm_ogg/secret_ending.ogg',
    category: 'music',
    loop: true,
    volume: 1,
    preload: true,
  },


  // Sound Effects
  {
    id: 'sfx_chicken',
    src: 'assets/audio/sfx/chicken.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_tinnitus',
    src: 'assets/audio/bgm/tinnitus.mp3',
    category: 'music',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_static',
    src: 'assets/audio/sfx/static.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_bladePierce',
    src: 'assets/audio/sfx/blade-pierce.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },  {
    id: 'sfx_running',
    src: 'assets/audio/sfx/running.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },

  {
    id: 'sfx_click',
    src: 'assets/audio/sfx/click.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_doorKnock',
    src: 'assets/audio/sfx/door-knock.mp3',
    category: 'sfx',
    volume: 1,
    preload: true,
  },
  {
    id: 'sfx_burn',
    src: 'assets/audio/sfx/burn.mp3',
    category: 'sfx',
    volume: 0.6,
    preload: true,
  },
  {
    id: 'sfx_doorSlam',
    src: 'assets/audio/sfx/door-slam.mp3',
    category: 'sfx',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_openDoor',
    src: 'assets/audio/sfx/open-door.mp3',
    category: 'sfx',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_girlScream',
    src: 'assets/audio/sfx/girl-scream.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_knifeStab',
    src: 'assets/audio/sfx/knife-stab.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_monsterLaugh',
    src: 'assets/audio/sfx/monster-laugh.mp3',
    category: 'sfx',
    volume: 0.6,
    preload: true,
  },
  {
    id: 'sfx_monsterScream',
    src: 'assets/audio/sfx/monster-scream.mp3',
    category: 'sfx',
    volume: 0.8,
    preload: true,
  },
  {
    id: 'sfx_orchestraFreak',
    src: 'assets/audio/sfx/orhcestra-freak.mp3',
    category: 'sfx',
    volume: 0.6,
    preload: true,
  },
  {
    id: 'sfx_swordSeathe',
    src: 'assets/audio/sfx/sword-seathe.mp3',
    category: 'sfx',
    volume: 0.5,
    preload: true,
  },
  {
    id: 'sfx_womanScream',
    src: 'assets/audio/sfx/woman-scream.mp3',
    category: 'sfx',
    volume: 0.7,
    preload: true,
  },
  {
    id: 'sfx_eating',
    src: 'assets/audio/sfx/eating.mp3',
    category: 'sfx',
    volume: 1,
    preload: true,
  },
  {
    id: 'sfx_heart',
    src: 'assets/audio/sfx/heart-beat.mp3',
    category: 'sfx',
    volume: 2,
    preload: true,
  },
];

/**
 * Get all assets that should be preloaded
 */
export function getPreloadAssets(): { images: ImageAssetConfig[], audio: AudioAssetConfig[] } {
  return {
    images: imageAssets.filter(asset => asset.preload !== false),
    audio: audioAssets.filter(asset => asset.preload !== false),
  };
}

/**
 * Get asset by ID
 */
export function getImageAsset(id: string): ImageAssetConfig | undefined {
  return imageAssets.find(asset => asset.id === id);
}

export function getAudioAsset(id: string): AudioAssetConfig | undefined {
  return audioAssets.find(asset => asset.id === id);
}

/**
 * Get assets by category
 */
export function getImageAssetsByCategory(category: ImageAssetConfig['category']): ImageAssetConfig[] {
  return imageAssets.filter(asset => asset.category === category);
}

export function getAudioAssetsByCategory(category: AudioAssetConfig['category']): AudioAssetConfig[] {
  return audioAssets.filter(asset => asset.category === category);
}
